"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-bold-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" }),
            _react2.default.createElement("path", { d: "M10 9h3.568c.544 0 1.048.04 1.512.12a3.6 3.6 0 0 1 1.216.424c.347.203.619.47.816.8.197.332.296.748.296 1.25 0 .235-.035.47-.104.704a2.196 2.196 0 0 1-.856 1.2c-.224.161-.485.278-.784.353v.064c.747.139 1.31.406 1.688.8.379.396.568.945.568 1.65 0 .533-.104.992-.312 1.377a2.688 2.688 0 0 1-.864.952 3.98 3.98 0 0 1-1.288.56 6.512 6.512 0 0 1-1.584.185H10V9zm3.456 4.21c.576 0 .995-.114 1.256-.343.261-.23.392-.542.392-.937s-.133-.678-.4-.849c-.267-.17-.677-.256-1.232-.256h-1.12v2.386h1.104zm.224 4.404c1.29 0 1.936-.475 1.936-1.425 0-.46-.16-.793-.48-1.001-.32-.208-.805-.312-1.456-.312h-1.328v2.738h1.328z", fill: "#4C4C4C" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-bold-on.js
// module id = 1875
// module chunks = 0